<template>
  <div id="view-footer">
    <template v-if="getTheme.footer.options.version !== 'CustomFooter'">
      <cms-footer
        v-if="footerSetUp"
        :theme="footerOptions"
        :content="getHomepage.footer"
        :organizations="getOrganizations"
        :current-domain="getHost"
        :ios-link="getIOSLink"
        :android-link="getAndroidLink"
      />
    </template>
    <template v-else>
      <cms-footer
        :theme="footerOptions"
        :content="getHomepage.footer"
        :organizations="getOrganizations"
        :current-domain="getHost"
        :ios-link="getIOSLink"
        :android-link="getAndroidLink"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../stores/mainStore.js';
import { useTranslationStore } from '../../../stores/translationStore.js';
import { isEmpty } from 'lodash';

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const getHomepage = computed(() => mainStore.getHomepage);
const getTheme = computed(() => mainStore.getTheme);
const getOrganizations = computed(() => mainStore.getOrganizations);
const getIOSLink = computed(() => mainStore.getIOSLink);
const getAndroidLink = computed(() => mainStore.getAndroidLink);
const getHost = computed(() => mainStore.getHost);

const footerSetUp = computed(() => getHomepage.value.footer && !isEmpty(getHomepage.value.footer));

const footerOptions = computed(() => ({
  ...getTheme.value.footer.options,
  translations: translationStore.getComponentTranslation('footer'),
}));
</script>

<style scoped lang="scss"></style>
